export const ECP_PROJECTS_IS_MODAL = "ECP_PROJECTS_IS_MODAL"
export const ECP_PROJECTS_IS_CONFIRMATION_MODAL = "ECP_PROJECTS_IS_CONFIRMATION_MODAL"
export const ECP_PROJECTS_SET_TAB = "ECP_PROJECTS_SET_TAB"
export const ECP_PROJECTS_SET_PAGE = "ECP_PROJECTS_SET_PAGE"
export const SET_ECP_PROJECT_ID = "SET_ECP_PROJECT_ID"
export const CLEAN_ECP_PROJECTS_CONTEXT = "CLEAN_ECP_PROJECTS_CONTEXT"